import * as React from 'react'
import { useTranslation, Link } from 'gatsby-plugin-react-i18next'
import cn from 'classnames'
import FillButton from 'components/presenter/buttons/FillButton'
import * as styles from './styles.module.css'

const SloganSection = () => {
  const { t } = useTranslation()
  return (
    <>
      <div className={cn(styles.sectionRoot)}>
        <h3>
          {t('landing.slogan')}
        </h3>
        <FillButton
          className={cn(styles.btnPromote, 'mui-btn-link')}>
          <Link
            to='/jetso/'>
            {t('landing.freePromote')}
          </Link>
        </FillButton>
      </div>
    </>
  )
}

export default SloganSection